<template>
 konsulentmagnus 2024. alle rettigheder er forbeholdt. <!-- Dit footer-indhold -->
</template>

<script>
export default {
  name: 'DetMedSmåt'  // Sørg for at navnet er multi-word
}
</script>

<style scoped>
/* Dine stilarter her */
</style>